var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBardSparkleV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 474,
    viewBox: "0 0 474 474",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423.211 212.022C309.7 218.869 218.866 309.705 212.02 423.216H211.191C204.344 309.705 113.51 218.869 0 212.022V211.194C113.51 204.348 204.344 113.512 211.191 0H212.02C218.866 113.512 309.7 204.348 423.211 211.194V212.022Z",
    fill: "url(#paint0_radial_7192_57059)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M473.998 389.524C428.594 392.263 392.261 428.597 389.522 474.002H389.191C386.452 428.597 350.118 392.263 304.714 389.524V389.193C350.118 386.454 386.452 350.12 389.191 304.715H389.522C392.261 350.12 428.594 386.454 473.998 389.193V389.524Z",
    fill: "url(#paint1_radial_7192_57059)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7192_57059",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42 172) rotate(18.6835) scale(450.455 3608.47)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671246,
    stopColor: "#9168C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342551,
    stopColor: "#5684D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672076,
    stopColor: "#1BA1E3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_7192_57059",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(321.514 373.515) rotate(18.6835) scale(180.182 1443.39)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0671246,
    stopColor: "#9168C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342551,
    stopColor: "#5684D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672076,
    stopColor: "#1BA1E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBardSparkleV2);
export default __webpack_public_path__ + "static/media/bard_sparkle_v2.5d0259b3b725d5634494915655298cd7.svg";
export { ForwardRef as ReactComponent };